import { BASEPATH } from "../../../utils/constants/constants";

export const CATALOG_VERSION_URL = {
  GET_CATALOG_VERSION: `${BASEPATH}/reports/getCatalogVersion`,
  UPDATE_CATALOG_VERSION: `${BASEPATH}/reports/updateCatalogVersion`,
}